<template>
  <div>
    <el-dialog
      :title="paymentFormTitle"
      :visible.sync="paymentModalVisible"
      :close-on-click-modal="false"
      @open="paymentModalShow"
      @close="paymentModalHide"
      :width="largeDialogWidth"
      top="1em"
      v-draggable
    >
      <el-dialog
        :title="$t('payment.searchSubscribersForm.modal.title')"
        :visible.sync="searchSubscribersModal"
        :close-on-click-modal="false"
        @close="searchSubscribersModalHide"
        width="55%"
        top="1em"
        append-to-body
        v-draggable
      >
        <div class="more-info__inner" ref="searchSubscribers">
          <el-form
            :model="searchSubscribersForm"
            :rules="searchSubscribersRules"
            ref="searchSubscribersForm"
          >
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>{{ $t("payment.searchSubscribersForm.form.fio") }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item>
                  <el-input
                    v-model="searchSubscribersForm.fullName"
                    clearable
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-select
                    v-model="searchSubscribersForm.fullNameTypeSearch"
                    :placeholder="$t('common.components.select.placeholder')"
                    filterable
                    size="small"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in searchTypesOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{ $t("payment.searchSubscribersForm.form.street") }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <currency-input
                  placeholder=""
                  v-model="searchSubscribersForm.codestreetCode"
                  @blur="onChangeCodestreetCode"
                  @keyup.enter.native="onChangeCodestreetCode"
                  :precision="0"
                  class="el-input--small el-input__inner"
                  style="width: 100%; height: 32px; line-height: 32px; margin-top: 3px;"
                />
              </el-col>
              <el-col :span="16">
                <el-form-item>
                  <el-select
                    v-model="searchSubscribersForm.streetCode"
                    :placeholder="$t('common.components.select.placeholder')"
                    clearable
                    filterable
                    size="small"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in params.street.data"
                      :key="`${item.coder}${item.codestreet}`"
                      :label="
                        `${item.typestr} ${item.namestreet} ${
                          item.oldnamestreet !== ''
                            ? '(' + item.oldnamestreet + ')'
                            : ''
                        }`
                      "
                      :value="item.codestreet"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{ $t("payment.searchSubscribersForm.form.house") }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <currency-input
                  placeholder=""
                  v-model="searchSubscribersForm.nHouse"
                  :precision="0"
                  class="el-input--small el-input__inner"
                  style="width: 100%; height: 32px; line-height: 32px; margin-top: 3px;"
                />
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-input
                    v-model="searchSubscribersForm.charHouse"
                    clearable
                    @input="
                      v => {
                        searchSubscribersForm.charHouse = v.toUpperCase();
                      }
                    "
                    maxlength="3"
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item>
                  <div style="text-align: right;">
                    {{ $t("payment.searchSubscribersForm.form.corpHouse") }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-input
                    v-model="searchSubscribersForm.corpHouse"
                    clearable
                    @input="
                      v => {
                        searchSubscribersForm.corpHouse = v.toUpperCase();
                      }
                    "
                    maxlength="3"
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>{{ $t("payment.searchSubscribersForm.form.flat") }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <currency-input
                  placeholder=""
                  v-model="searchSubscribersForm.nFlat"
                  :precision="0"
                  class="el-input--small el-input__inner"
                  style="width: 100%; height: 32px; line-height: 32px; margin-top: 3px;"
                />
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-input
                    v-model="searchSubscribersForm.charFlat"
                    clearable
                    @input="
                      v => {
                        searchSubscribersForm.charFlat = v.toUpperCase();
                      }
                    "
                    maxlength="3"
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="13"> </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{ $t("payment.searchSubscribersForm.form.ncount") }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item>
                  <el-input
                    v-model="searchSubscribersForm.ncount"
                    clearable
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-select
                    v-model="searchSubscribersForm.ncountTypeSearch"
                    :placeholder="$t('common.components.select.placeholder')"
                    filterable
                    size="small"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in searchTypesOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{ $t("payment.searchSubscribersForm.form.nplomb") }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item>
                  <el-input
                    v-model="searchSubscribersForm.plombNumber"
                    clearable
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-select
                    v-model="searchSubscribersForm.plombNumberTypeSearch"
                    :placeholder="$t('common.components.select.placeholder')"
                    filterable
                    size="small"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in searchTypesOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="extendedSearch">
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{ $t("payment.searchSubscribersForm.form.inn") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item>
                    <el-input
                      v-model="searchSubscribersForm.docnumber"
                      clearable
                      size="small"
                      style="width: 100%;"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item>
                    <el-select
                      v-model="searchSubscribersForm.docnumberTypeSearch"
                      :placeholder="$t('common.components.select.placeholder')"
                      filterable
                      size="small"
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in searchTypesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{ $t("payment.searchSubscribersForm.form.eic") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item>
                    <el-input
                      v-model="searchSubscribersForm.eic"
                      clearable
                      size="small"
                      style="width: 100%;"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item>
                    <el-select
                      v-model="searchSubscribersForm.eicTypeSearch"
                      :placeholder="$t('common.components.select.placeholder')"
                      filterable
                      size="small"
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in searchTypesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{ $t("payment.searchSubscribersForm.form.abcode") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item>
                    <el-input
                      v-model="searchSubscribersForm.abcode"
                      clearable
                      size="small"
                      style="width: 100%;"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item>
                    <el-select
                      v-model="searchSubscribersForm.abcodeTypeSearch"
                      :placeholder="$t('common.components.select.placeholder')"
                      filterable
                      size="small"
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in searchTypesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{ $t("payment.searchSubscribersForm.form.abcodeBegin") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <el-date-picker
                      v-model="searchSubscribersForm.dateBegin"
                      type="date"
                      :placeholder="
                        $t('common.components.datePicker.placeholder')
                      "
                      format="dd.MM.yyyy"
                      value-format="dd.MM.yyyy"
                      :picker-options="pickerOptions"
                      size="small"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item>
                    <div style="text-align: right;">
                      {{ $t("payment.searchSubscribersForm.form.abcodeEnd") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item style="text-align: right;">
                    <el-date-picker
                      v-model="searchSubscribersForm.dateEnd"
                      type="date"
                      :placeholder="
                        $t('common.components.datePicker.placeholder')
                      "
                      format="dd.MM.yyyy"
                      value-format="dd.MM.yyyy"
                      :picker-options="pickerOptions"
                      size="small"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{ $t("payment.searchSubscribersForm.form.area") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <currency-input
                    placeholder=""
                    v-model="searchSubscribersForm.codedistrictCode"
                    @blur="onChangeCodedistrictCode"
                    @keyup.enter.native="onChangeCodedistrictCode"
                    :precision="0"
                    class="el-input--small el-input__inner"
                    style="width: 100%; height: 32px; line-height: 32px; margin-top: 3px;"
                  />
                </el-col>
                <el-col :span="16">
                  <el-form-item>
                    <el-select
                      v-model="searchSubscribersForm.districtCode"
                      :placeholder="$t('common.components.select.placeholder')"
                      clearable
                      filterable
                      size="small"
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in params.gregion.data"
                        :key="item.coder"
                        :label="item.nameadminreg"
                        :value="item.coder"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{ $t("payment.searchSubscribersForm.form.nact") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item>
                    <el-input
                      v-model="searchSubscribersForm.actNumber"
                      clearable
                      size="small"
                      style="width: 100%;"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item>
                    <el-select
                      v-model="searchSubscribersForm.actNumberTypeSearch"
                      :placeholder="$t('common.components.select.placeholder')"
                      filterable
                      size="small"
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in searchTypesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{ $t("payment.searchSubscribersForm.form.fioPerson") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item>
                    <el-input
                      v-model="searchSubscribersForm.individualFullName"
                      clearable
                      size="small"
                      style="width: 100%;"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item>
                    <el-select
                      v-model="
                        searchSubscribersForm.individualFullNameTypeSearch
                      "
                      :placeholder="$t('common.components.select.placeholder')"
                      filterable
                      size="small"
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in searchTypesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{ $t("payment.searchSubscribersForm.form.nbid") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <currency-input
                    placeholder=""
                    v-model="searchSubscribersForm.requestId"
                    :precision="0"
                    class="el-input--small el-input__inner"
                    style="width: 100%; height: 32px; line-height: 32px; margin-top: 3px;"
                  />
                </el-col>
                <el-col :span="14"> </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{ $t("payment.searchSubscribersForm.form.naccount") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <currency-input
                    placeholder=""
                    v-model="searchSubscribersForm.accountNumber"
                    :precision="0"
                    class="el-input--small el-input__inner"
                    style="width: 100%; height: 32px; line-height: 32px; margin-top: 3px;"
                  />
                </el-col>
                <el-col :span="14"> </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{ $t("payment.searchSubscribersForm.form.ncontract") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item>
                    <el-input
                      v-model="searchSubscribersForm.contractNumber"
                      clearable
                      size="small"
                      style="width: 100%;"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item>
                    <el-select
                      v-model="searchSubscribersForm.contractNumberTypeSearch"
                      :placeholder="$t('common.components.select.placeholder')"
                      filterable
                      size="small"
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in searchTypesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{ $t("payment.searchSubscribersForm.form.phone") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item>
                    <el-input
                      v-model="searchSubscribersForm.phoneNumber"
                      clearable
                      size="small"
                      style="width: 100%;"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item>
                    <el-select
                      v-model="searchSubscribersForm.phoneNumberTypeSearch"
                      :placeholder="$t('common.components.select.placeholder')"
                      filterable
                      size="small"
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in searchTypesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                :gutter="5"
                style="margin-right: 1em"
              >
                <el-col :span="5">
                  <el-form-item>
                    <div>
                      {{
                        $t("payment.searchSubscribersForm.form.nHouseAccount")
                      }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item>
                    <el-input
                      v-model="searchSubscribersForm.houseAccountNumber"
                      clearable
                      size="small"
                      style="width: 100%;"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item>
                    <el-select
                      v-model="
                        searchSubscribersForm.houseAccountNumberTypeSearch
                      "
                      :placeholder="$t('common.components.select.placeholder')"
                      filterable
                      size="small"
                      style="width: 100%;"
                    >
                      <el-option
                        v-for="item in searchTypesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="24">
                <el-form-item>
                  <el-checkbox
                    v-model="extendedSearch"
                    v-shortkey="{ F2: ['f2'] }"
                    @shortkey.native="onShortKeyRouter"
                  >
                    {{
                      $t("payment.searchSubscribersForm.extendedSearch")
                    }}</el-checkbox
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-row type="flex" justify="space-between">
            <el-col :span="24" style="text-align:right;">
              <el-button
                type="primary"
                size="small"
                @click="searchSubscribersFormSubmit"
                native-type="submit"
                v-shortkey="{ F10: ['f10'] }"
                @shortkey.native="onShortKeyRouter"
                ><span class="key-name">F10</span
                >{{ $t("common.buttons.submit") }}</el-button
              >
              <el-button
                type="plain"
                size="small"
                @click="searchSubscribersModal = false"
                ><span class="key-name">Esc</span
                >{{ $t("common.buttons.cancel") }}</el-button
              >
              <el-button
                type="plain"
                size="small"
                icon="fas fa-broom"
                @click="searchSubscribersFormClear"
                v-shortkey="{ F12: ['f12'] }"
                @shortkey.native="onShortKeyRouter"
              >
              </el-button>
              <el-button
                type="plain"
                size="small"
                icon="fas fa-question"
                @click="searchSubscribersFormHelp"
                v-shortkey="{ F1: ['f1'] }"
                @shortkey.native="onShortKeyRouter"
              >
              </el-button>
            </el-col>
          </el-row>
        </span>
      </el-dialog>

      <el-dialog
        :title="$t('payment.searchResultsForm.modal.title')"
        :visible.sync="searchResultsModal"
        :close-on-click-modal="false"
        @close="searchResultsModalHide"
        fullscreen
        append-to-body
      >
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <div class="grid-container-modal">
              <ag-grid-vue
                style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
                class="ag-theme-balham"
                rowSelection="single"
                :defaultColDef="defaultColDef"
                :columnDefs="searchResultsColumnDefs"
                :rowData="paymentSubscribers"
                :gridOptions="searchResultsGridOptions"
                @grid-ready="onSearchResultsGridReady"
                @first-data-rendered="onSearchResultsFirstDataRendered"
                @modelUpdated="onSearchResultsModelUpdated"
                @rowSelected="onSearchResultsRowSelected"
                @rowDoubleClicked="onSearchResultsRowDoubleClicked"
                @cellContextMenu="onSearchResultsRowRightClicked"
              ></ag-grid-vue>
            </div>
          </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
          <el-row type="flex" justify="space-between">
            <el-col :span="12" style="text-align:left; margin-top:7px;">
              <div>
                {{ $t("payment.searchResultsForm.selectedRows") }}
                {{ searchResultsRowCount }}
              </div>
            </el-col>
            <el-col :span="12" style="text-align:right;">
              <el-button
                type="primary"
                size="small"
                @click="searchResultsModalSubmit"
                native-type="submit"
                :disabled="submitSearchResultsBtnDisabled"
                v-shortkey="{ Enter: ['enter'], F10: ['f10'] }"
                @shortkey.native="onShortKeyRouter"
                ><span class="key-name">F10</span
                >{{ $t("common.buttons.submit") }}</el-button
              >
              <el-button
                type="plain"
                size="small"
                @click="searchResultsModal = false"
                ><span class="key-name">Esc</span
                >{{ $t("common.buttons.cancel") }}</el-button
              >
            </el-col>
          </el-row>
        </span>
      </el-dialog>

      <div class="more-info__inner" ref="payment">
        <el-form :model="paymentForm" :rules="paymentRules" ref="paymentForm">
          <el-row type="flex" justify="space-between" style="margin-right: 1em">
            <el-col :span="12">
              <el-form-item
                :label="$t('payment.paymentForm.form.abcode')"
                label-width="150px"
              >
                <el-input
                  v-model="paymentForm.abcode"
                  clearable
                  size="small"
                  style="width: 100%;"
                  class="mixed-input-no-radius"
                  @input="
                    v => {
                      paymentForm.abcode = v.toUpperCase();
                    }
                  "
                  @change="onAbcodeChange"
                  @shortkey.native="onShortKeyRouter"
                  :disabled="paymentFormIsDel"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="paymentFormSearch"
                    v-shortkey="{ F7: ['f7'] }"
                    @shortkey.native="onShortKeyRouter"
                    :disabled="paymentFormIsDel"
                  ></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="text-align:right;">
              <el-form-item>
                <span class="info">{{ paymentInfo }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <div v-if="paymentAbcodeFound">
            <el-row
              type="flex"
              justify="space-between"
              style="margin-right: 1em"
            >
              <el-col :span="20">
                <el-form-item
                  :label="$t('payment.paymentForm.form.fullname')"
                  label-width="150px"
                >
                  <el-input
                    v-model="paymentForm.fullName"
                    clearable
                    disabled
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4" style="text-align:right;">
                <el-form-item>
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-user-solid"
                    :disabled="aboutClientBtnDisabled"
                    @click="onAboutClientBtn"
                    >{{ $t("common.buttons.aboutClient") }}</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              style="margin-right: 1em"
            >
              <el-col :span="24">
                <el-form-item
                  :label="$t('payment.paymentForm.form.address')"
                  label-width="150px"
                >
                  <el-input
                    v-model="paymentForm.address"
                    clearable
                    disabled
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              style="margin-right: 1em"
            >
              <el-col :span="12">
                <el-form-item
                  :label="$t('payment.paymentForm.form.dateBegin')"
                  label-width="150px"
                >
                  <el-date-picker
                    v-model="paymentForm.dateBegin"
                    disabled
                    size="small"
                    type="date"
                    :placeholder="
                      $t('common.components.datePicker.placeholder')
                    "
                    format="dd.MM.yyyy"
                    value-format="dd.MM.yyyy"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="text-align:right;">
                <el-form-item>
                  <div>{{ $t("payment.paymentForm.form.dateEnd") }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="text-align:right;">
                <el-form-item>
                  <el-date-picker
                    v-model="paymentForm.dateEnd"
                    disabled
                    size="small"
                    type="date"
                    :placeholder="
                      $t('common.components.datePicker.placeholder')
                    "
                    format="dd.MM.yyyy"
                    value-format="dd.MM.yyyy"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-else>
            <el-row
              type="flex"
              justify="space-between"
              style="margin-right: 1em"
            >
              <el-col :span="24">
                <el-form-item>
                  <div class="abcode-not-found">
                    {{ $t("payment.paymentForm.abcodeNotFound") }}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-divider></el-divider>
          <el-tabs
            type="card"
            v-model="paymentActiveTabName"
            @tab-click="onPaymentActiveTabClick"
          >
            <el-tab-pane
              id="tab-0"
              :key="1"
              name="pay"
              :label="$t('payment.paymentForm.form.payTab.title')"
            >
              <el-row
                type="flex"
                justify="space-between"
                style="margin-right: 1em"
              >
                <el-col :span="12" style="text-align:left;">
                  <el-form-item
                    prop="datePay"
                    :label="$t('payment.paymentForm.form.payTab.datePay')"
                    label-width="150px"
                  >
                    <el-date-picker
                      v-model="paymentForm.datePay"
                      size="small"
                      type="date"
                      :placeholder="
                        $t('common.components.datePicker.placeholder')
                      "
                      format="dd.MM.yyyy"
                      value-format="dd.MM.yyyy"
                      :picker-options="pickerOptions"
                      :disabled="paymentFormIsDel"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6" style="text-align:right;">
                  <el-form-item>
                    <div>
                      {{ $t("payment.paymentForm.form.payTab.dateBank") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6" style="text-align:right;">
                  <el-form-item>
                    <el-date-picker
                      v-model="paymentForm.dateBank"
                      disabled
                      size="small"
                      type="date"
                      :placeholder="
                        $t('common.components.datePicker.placeholder')
                      "
                      format="dd.MM.yyyy"
                      value-format="dd.MM.yyyy"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                style="margin-right: 1em"
                :gutter="5"
              >
                <el-col :span="10" style="text-align:left;">
                  <el-form-item
                    prop="sumPay"
                    :label="$t('payment.paymentForm.form.payTab.sumPay')"
                    label-width="150px"
                  >
                    <currency-input
                      placeholder="0.00"
                      v-model.lazy="paymentForm.sumPay"
                      :disabled="paymentFormSumPayDisabled"
                      class="el-input--small el-input__inner"
                      :class="{ moneydisable: paymentFormSumPayDisabled }"
                      style="width: 100%; height: 32px; line-height: 32px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="1" style="text-align:left;">
                  <el-form-item>
                    <el-button
                      v-if="paymentForm.note"
                      size="small"
                      icon="el-icon-document"
                      @click="onClickPaymentNote"
                      v-shortkey="{ F3: ['f3'] }"
                      @shortkey.native="onShortKeyRouter"
                    ></el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="7" style="text-align:right;">
                  <el-form-item>
                    <div>
                      {{ $t("payment.paymentForm.form.payTab.numPayDoc") }}
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6" style="text-align:right;">
                  <el-form-item>
                    <el-input
                      v-model="paymentForm.numPayDoc"
                      style="width: 220px;"
                      size="small"
                      :disabled="paymentFormIsDel"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-if="paymentFormIsEditDel">
                <el-row
                  type="flex"
                  justify="space-between"
                  style="margin-right: 1em"
                >
                  <el-col :span="24">
                    <el-form-item
                      :label="$t('payment.paymentForm.form.payTab.methodPay')"
                      label-width="150px"
                    >
                      <el-row type="flex" justify="space-between" :gutter="5">
                        <el-col :span="2">
                          <currency-input
                            placeholder="0"
                            v-model="paymentForm.kindpayCode"
                            :precision="0"
                            class="el-input--small el-input__inner"
                            style="width: 100%; height: 32px; line-height: 32px;"
                            disabled
                            :class="{ moneydisable: true }"
                          />
                        </el-col>
                        <el-col :span="22">
                          <el-select
                            v-model="paymentForm.kindpay"
                            :placeholder="
                              $t('common.components.select.placeholder')
                            "
                            clearable
                            filterable
                            style="width: 100%;"
                            size="small"
                            disabled
                          >
                            <el-option
                              v-for="item in params.gkindpay.data"
                              :key="item.kindpay"
                              :label="item.kindname"
                              :value="item.kindpay"
                            ></el-option>
                          </el-select>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  justify="space-between"
                  style="margin-right: 1em"
                >
                  <el-col :span="24">
                    <el-form-item
                      :label="$t('payment.paymentForm.form.payTab.orgPay')"
                      label-width="150px"
                    >
                      <el-row type="flex" justify="space-between" :gutter="5">
                        <el-col :span="2">
                          <currency-input
                            placeholder="0"
                            v-model="paymentForm.codefirmeCode"
                            :precision="0"
                            class="el-input--small el-input__inner"
                            style="width: 100%; height: 32px; line-height: 32px;"
                            disabled
                            :class="{ moneydisable: true }"
                          />
                        </el-col>
                        <el-col :span="22">
                          <el-select
                            v-model="paymentForm.codefirme"
                            :placeholder="
                              $t('common.components.select.placeholder')
                            "
                            clearable
                            filterable
                            style="width: 100%;"
                            size="small"
                            disabled
                          >
                            <el-option
                              v-for="item in params.gfirme.data"
                              :key="item.codefirme"
                              :label="item.namefirme"
                              :value="item.codefirme"
                            ></el-option>
                          </el-select>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  justify="space-between"
                  style="margin-right: 1em"
                >
                  <el-col :span="24">
                    <el-form-item
                      :label="$t('payment.paymentForm.form.payTab.accountPay')"
                      label-width="150px"
                    >
                      <el-input
                        v-model="paymentForm.accountPay"
                        disabled
                        clearable
                        size="small"
                        style="width: 100%;"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-row
                type="flex"
                justify="space-between"
                style="margin-right: 1em"
              >
                <el-col :span="24">
                  <el-form-item
                    prop="purpPayCode"
                    :label="$t('payment.paymentForm.form.payTab.purpPay')"
                    label-width="150px"
                  >
                    <el-row type="flex" justify="space-between" :gutter="5">
                      <el-col :span="2">
                        <currency-input
                          placeholder=""
                          v-model="paymentForm.codepurpPayCode"
                          @blur="onChangeCodepurpPayCode"
                          @keyup.enter.native="onChangeCodepurpPayCode"
                          :precision="0"
                          class="el-input--small el-input__inner"
                          style="width: 100%; height: 32px; line-height: 32px;"
                          :disabled="paymentFormIsDel"
                          :class="{ moneydisable: paymentFormIsDel }"
                        />
                      </el-col>
                      <el-col :span="19">
                        <el-select
                          v-model="paymentForm.purpPayCode"
                          :placeholder="
                            $t('common.components.select.placeholder')
                          "
                          clearable
                          filterable
                          style="width: 100%;"
                          size="small"
                          :disabled="paymentFormIsDel"
                        >
                          <el-option
                            v-for="item in params.codepay.data"
                            :key="item.codeplat"
                            :label="item.name"
                            :value="item.codeplat"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="3" style="text-align:right;">
                        <el-form-item>
                          {{ $t("payment.paymentForm.actSwitcher") }}
                          <el-checkbox
                            v-model="paymentForm.act"
                            :disabled="
                              paymentFormIsEditDel || paymentForm.actDisabled
                            "
                            v-shortkey="{ F2: ['f2'] }"
                            @shortkey.native="onShortKeyRouter"
                          ></el-checkbox>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                style="margin-right: 1em"
              >
                <el-col :span="24">
                  <el-form-item
                    :label="$t('payment.paymentForm.form.payTab.statusPay')"
                    label-width="150px"
                  >
                    <el-row type="flex" justify="space-between" :gutter="5">
                      <el-col :span="2">
                        <currency-input
                          placeholder="0"
                          v-model="paymentForm.codestatusPayCode"
                          @blur="onChangeCodestatusPayCode"
                          @keyup.enter.native="onChangeCodestatusPayCode"
                          :precision="0"
                          class="el-input--small el-input__inner"
                          style="width: 100%; height: 32px; line-height: 32px;"
                          :disabled="paymentFormIsDel"
                          :class="{ moneydisable: paymentFormIsDel }"
                        />
                      </el-col>
                      <el-col :span="22">
                        <el-select
                          v-model="paymentForm.statusPayCode"
                          :placeholder="
                            $t('common.components.select.placeholder')
                          "
                          clearable
                          filterable
                          style="width: 100%;"
                          size="small"
                          :disabled="paymentFormIsDel"
                        >
                          <el-option
                            v-for="item in params.statuspay.data"
                            :key="item.coderr"
                            :label="item.nameerr"
                            :value="item.coderr"
                          ></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-if="paymentFormType">
                <el-row
                  type="flex"
                  justify="space-between"
                  style="margin-right: 1em"
                >
                  <el-col :span="10" style="text-align:left;">
                    <el-form-item
                      prop="datePayFrom"
                      :label="$t('payment.paymentForm.form.payTab.datePayFrom')"
                      label-width="150px"
                    >
                      <el-date-picker
                        v-model="paymentForm.datePayFrom"
                        size="small"
                        type="date"
                        :placeholder="
                          $t('common.components.datePicker.placeholder')
                        "
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        :disabled="paymentFormIsDel"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" style="text-align:center;">
                    <el-form-item>
                      <div>
                        {{ $t("payment.paymentForm.form.payTab.datePayTo") }}
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="13" style="text-align:left;">
                    <el-form-item>
                      <el-date-picker
                        v-model="paymentForm.datePayTo"
                        size="small"
                        type="date"
                        :placeholder="
                          $t('common.components.datePicker.placeholder')
                        "
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        :disabled="paymentFormIsDel"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  justify="space-between"
                  style="margin-right: 1em"
                  :gutter="5"
                >
                  <el-col :span="10" style="text-align:left;">
                    <el-form-item
                      :label="$t('payment.paymentForm.form.payTab.sumPayMust')"
                      label-width="150px"
                    >
                      <currency-input
                        placeholder="0.00"
                        v-model.lazy="paymentForm.sumPayMust"
                        class="el-input--small el-input__inner"
                        style="width: 100%; height: 32px; line-height: 32px;"
                        :disabled="isSumPayMustDisabled"
                        :class="{ moneydisable: isSumPayMustDisabled }"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="14" style="text-align:right;">
                    <el-form-item> </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div v-else>
                <el-row
                  type="flex"
                  justify="space-between"
                  style="margin-right: 1em"
                >
                  <el-col :span="10" style="text-align:left;">
                    <el-form-item
                      :label="
                        $t('payment.paymentForm.form.payTab.dateSaveReadings')
                      "
                      label-width="150px"
                    >
                      <el-date-picker
                        v-model="paymentForm.dateSaveReadings"
                        size="small"
                        type="date"
                        :placeholder="
                          $t('common.components.datePicker.placeholder')
                        "
                        @change="onDateSaveReadingsChanged"
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        :disabled="isDolg || paymentFormIsDel"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="14" style="text-align:right;">
                    <el-form-item>
                      <el-dropdown trigger="click">
                        <el-button
                          type="primary"
                          size="small"
                          :disabled="isDolg || paymentFormIsDel"
                        >
                          {{
                            $t("payment.paymentForm.buttons.AddReadingOneZone")
                          }}
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            @click.native="onAddOneZoneAbstractReadingsBtn"
                            >{{
                              $t(
                                "payment.paymentForm.buttons.AddReadingOneZone"
                              )
                            }}</el-dropdown-item
                          >
                          <el-dropdown-item
                            @click.native="onAddTwoZoneAbstractReadingsBtn"
                            >{{
                              $t(
                                "payment.paymentForm.buttons.AddReadingTwoZone"
                              )
                            }}</el-dropdown-item
                          >
                          <el-dropdown-item
                            @click.native="onAddThreeZoneAbstractReadingsBtn"
                            >{{
                              $t(
                                "payment.paymentForm.buttons.AddReadingThreeZone"
                              )
                            }}</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button
                        type="primary"
                        size="small"
                        style="margin-left:1em;"
                        @click.native="onDeleteAbstractReadingsBtn"
                        :disabled="isDolg || paymentFormIsDel"
                        >{{
                          $t("payment.paymentForm.buttons.DeleteReading")
                        }}</el-button
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  justify="space-between"
                  style="margin-bottom: 10px; margin-right: 1em"
                >
                  <el-col :span="24">
                    <div class="grid-container-counters">
                      <ag-grid-vue
                        style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
                        class="ag-theme-balham"
                        rowSelection="single"
                        :defaultColDef="countersDefaultColDef"
                        :columnDefs="countersColumnDefs"
                        :rowData="paymentCounters"
                        :gridOptions="countersGridOptions"
                        :getRowStyle="countersGetRowStyle"
                        :frameworkComponents="countersFrameworkComponents"
                        :stopEditingWhenCellsLoseFocus="true"
                        :undoRedoCellEditing="true"
                        :undoRedoCellEditingLimit="1"
                        :enableCellChangeFlash="true"
                        @grid-ready="onCountersGridReady"
                        @first-data-rendered="onCountersFirstDataRendered"
                        @gridSizeChanged="onGridSizeChanged"
                        @modelUpdated="onCountersModelUpdated"
                        @rowSelected="onCountersRowSelected"
                        @cellEditingStarted="onCountersCellEditingStarted"
                        @cellEditingStopped="onCountersCellEditingStopped"
                        @cellContextMenu="onCountersRowRightClicked"
                      ></ag-grid-vue>
                    </div>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  justify="space-between"
                  style="margin-right: 1em"
                >
                  <el-col :span="24">
                    <el-form-item style="margin-bottom: 0px;">
                      <el-row type="flex" justify="space-between" :gutter="5">
                        <el-col :span="11" style="text-align:left;">
                          <el-form-item>
                            <div>
                              {{
                                $t("payment.paymentForm.form.payTab.counter")
                              }}
                            </div>
                          </el-form-item>
                        </el-col>
                        <el-col :span="7">
                          <el-form-item>
                            <div>
                              {{
                                $t(
                                  "payment.paymentForm.form.payTab.dateReading"
                                )
                              }}
                              {{ paymentForm.dateReading }}
                            </div>
                          </el-form-item>
                        </el-col>
                        <el-col :span="3" style="text-align:right;">
                          <el-form-item>
                            <div>
                              {{
                                $t("payment.paymentForm.form.payTab.current")
                              }}
                            </div>
                          </el-form-item>
                        </el-col>
                        <el-col :span="3" style="text-align:right;">
                          <el-form-item>
                            <div>
                              {{
                                $t("payment.paymentForm.form.payTab.difference")
                              }}
                            </div>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row
                  type="flex"
                  justify="space-between"
                  style="margin-right: 1em"
                >
                  <el-col :span="24">
                    <el-form-item style="margin-bottom: 0px;">
                      <el-row type="flex" justify="space-between" :gutter="5">
                        <el-col :span="11">
                          <el-form-item>
                            <el-input
                              v-model="paymentForm.ncount"
                              clearable
                              disabled
                              size="small"
                              style="width: 100%;"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="2">
                          <el-form-item>
                            <el-input
                              v-model="paymentForm.perekrutFact"
                              disabled
                              size="small"
                              style="width: 100%; direction: rtl;"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="3">
                          <el-form-item>
                            <el-input
                              v-model="paymentForm.counter"
                              disabled
                              size="small"
                              style="width: 100%; direction: rtl;"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="2">
                          <el-form-item>
                            <el-input
                              v-model="paymentForm.perekrutCalc"
                              disabled
                              size="small"
                              style="width: 100%; direction: rtl;"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="3">
                          <el-form-item>
                            <el-input
                              v-model="paymentForm.readingInput"
                              disabled
                              size="small"
                              style="width: 100%; direction: rtl;"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="3">
                          <el-form-item>
                            <el-input
                              v-model="paymentForm.readingDiff"
                              disabled
                              size="small"
                              style="width: 100%; direction: rtl;"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane
              v-if="paymentForm.act"
              id="tab-1"
              :key="2"
              name="act"
              :label="$t('payment.paymentForm.form.actTab.title')"
            >
              <el-row
                type="flex"
                justify="space-between"
                style="margin-right: 1em"
              >
                <el-col :span="24">
                  <el-form-item
                    :label="$t('payment.paymentForm.form.actTab.act')"
                    label-width="150px"
                  >
                    <el-row type="flex" justify="space-between" :gutter="5">
                      <el-col :span="24">
                        <el-select
                          v-model="paymentForm.actId"
                          :placeholder="
                            $t('common.components.select.placeholder')
                          "
                          clearable
                          filterable
                          style="width: 100%;"
                          size="small"
                        >
                          <el-option
                            v-for="item in paymentActs.data"
                            :key="item.actid"
                            :label="
                              `№: ${item.nact} ${$t(
                                'payment.paymentForm.form.actTab.actDate'
                              )} ${item.dateact} ${$t(
                                'payment.paymentForm.form.actTab.actSum'
                              )} ${item.summact} ${$t(
                                'payment.paymentForm.form.actTab.actType'
                              )} ${item.typerobenameshort}`
                            "
                            :value="item.actid"
                          ></el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="space-between"
                style="margin-right: 1em"
              >
                <el-col :span="24">
                  <el-form-item
                    :label="$t('payment.paymentForm.form.actTab.note')"
                    label-width="150px"
                  >
                    <el-row type="flex" justify="space-between" :gutter="5">
                      <el-col :span="24">
                        <el-input
                          v-model="paymentForm.actNote"
                          type="textarea"
                          :rows="10"
                          resize="none"
                          style="width: 100%;"
                        ></el-input>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane
              v-if="paymentFormIsEditDel"
              id="tab-2"
              :key="3"
              name="note"
              :label="$t('payment.paymentForm.form.noteTab.title')"
            >
              <el-row
                type="flex"
                justify="space-between"
                style="margin-right: 1em"
              >
                <el-col :span="24">
                  <el-form-item>
                    <el-row type="flex" justify="space-between" :gutter="5">
                      <el-col :span="24">
                        <el-input
                          v-model="paymentForm.prim"
                          type="textarea"
                          :rows="10"
                          resize="none"
                          :disabled="paymentFormIsDel"
                          style="width: 100%;"
                        ></el-input>
                      </el-col>
                    </el-row>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="12" style="text-align:left;">
            <el-button
              type="primary"
              size="small"
              @click="paymentFormAdd"
              v-shortkey="{ Insert: ['insert'] }"
              @shortkey.native="onShortKeyRouter"
              v-if="paymentFormAddBtn"
              ><span class="key-name">Ins</span
              >{{ $t("common.buttons.add") }}</el-button
            >
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="paymentFormSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ paymentSubmitInfo }}</el-button
            >
            <el-button
              type="plain"
              size="small"
              @click="paymentModalVisible = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <SubscriberCard
      :abcode="paymentForm.abcode"
      :userinfo="subscriberInfo"
    ></SubscriberCard>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import { AllCommunityModules } from "@ag-grid-community/all-modules";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import NumericEditor from "@/components/NumericEditor";
import { $ } from "moneysafe";
import SubscriberCard from "@/components/SubscriberCard";
import { setGridView } from "@/helpers/grid";
import { pickerOptions } from "@/mixins/pickerOptions";
import { dialogWidth } from "@/mixins/dialogWidth";

export default {
  name: "payment",
  components: {
    AgGridVue,
    SubscriberCard
  },
  mixins: [pickerOptions, dialogWidth],
  data() {
    const validateDatePay = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.datepay.message")));
      } else if (
        this.paymentForm.abcode &&
        this.$moment(this.paymentForm.dateBegin, "DD.MM.YYYY").isAfter(
          this.$moment(value, "DD.MM.YYYY"),
          "day"
        )
      ) {
        callback(new Error(this.$t("common.validations.datepay.dateCompare")));
      } else {
        callback();
      }
    };
    const validatePurpPayCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.codepay.message")));
      } else {
        callback();
      }
    };
    const validateSumPay = (rule, value, callback) => {
      if (this.params.goptions.allowzeropays !== "yes" && value === 0) {
        callback(new Error(this.$t("common.validations.sumPay.sumGrtZero")));
      } else if (
        this.params.goptions.allowzeropays === "yes" &&
        value === null
      ) {
        callback(new Error(this.$t("common.validations.sumPay.message")));
      } else {
        callback();
      }
    };
    const validateDatePayFrom = (rule, value, callback) => {
      if (this.paymentFormType && !value) {
        callback(
          new Error(this.$t("common.validations.datePayPeriod.message"))
        );
      } else if (this.paymentFormType && !this.paymentForm.datePayTo) {
        callback(
          new Error(this.$t("common.validations.datePayPeriod.datePayEnd"))
        );
      } else if (
        this.paymentFormType &&
        this.$moment(value, "DD.MM.YYYY").isAfter(
          this.$moment(this.paymentForm.datePayTo, "DD.MM.YYYY"),
          "day"
        )
      ) {
        callback(
          new Error(this.$t("common.validations.datePayPeriod.datePayCompare"))
        );
      } else {
        callback();
      }
    };
    return {
      agGridModules: AllCommunityModules,
      agGridlocaleText: null,
      searchResultsGridOptions: null,
      searchResultsGridApi: null,
      searchResultsColumnApi: null,
      countersGridOptions: null,
      countersGridApi: null,
      countersColumnApi: null,
      countersFrameworkComponents: null,
      countersGetRowStyle: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        autoHeight: false,
        filterParams: {
          applyButton: false,
          clearButton: true
        },
        headerClass: "ag-grid-header",
        cellClass: "ag-grid-cell"
      },
      countersDefaultColDef: {
        resizable: true,
        sortable: false,
        filter: false,
        autoHeight: false,
        headerClass: "ag-grid-header",
        cellClass: "ag-grid-cell"
      },
      searchResultsColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.clientId"),
          headerTooltip: this.$t("common.gridColumns.clientId"),
          field: "clientid",
          tooltipField: "clientid",
          comparator: (value1, value2) =>
            parseFloat(value1) - parseFloat(value2)
        },
        {
          headerName: this.$t("common.gridColumns.abcode"),
          headerTooltip: this.$t("common.gridColumns.abcode"),
          field: "abcode",
          tooltipField: "abcode"
        },
        {
          headerName: this.$t("common.gridColumns.fio"),
          headerTooltip: this.$t("common.gridColumns.fio"),
          field: "fio",
          tooltipField: "fio",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.regionName"),
          headerTooltip: this.$t("common.gridColumns.regionName"),
          field: "regionname",
          tooltipField: "regionname"
        },
        {
          headerName: this.$t("common.gridColumns.streetName"),
          headerTooltip: this.$t("common.gridColumns.streetName"),
          field: "streetname",
          tooltipField: "streetname"
        },
        {
          headerName: this.$t("common.gridColumns.nHouse"),
          headerTooltip: this.$t("common.gridColumns.nHouse"),
          field: "nhouse",
          tooltipField: "nhouse",
          comparator: (value1, value2) =>
            parseFloat(value1) - parseFloat(value2)
        },
        {
          headerName: this.$t("common.gridColumns.charHouse"),
          headerTooltip: this.$t("common.gridColumns.charHouse"),
          field: "charhouse",
          tooltipField: "charhouse"
        },
        {
          headerName: this.$t("common.gridColumns.nFlat"),
          headerTooltip: this.$t("common.gridColumns.nFlat"),
          field: "nflat",
          tooltipField: "nflat",
          comparator: (value1, value2) =>
            parseFloat(value1) - parseFloat(value2)
        },
        {
          headerName: this.$t("common.gridColumns.charFlat"),
          headerTooltip: this.$t("common.gridColumns.charFlat"),
          field: "charflat",
          tooltipField: "charflat"
        },
        {
          headerName: this.$t("common.gridColumns.phone"),
          headerTooltip: this.$t("common.gridColumns.phone"),
          field: "phone",
          tooltipField: "phone",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.dateCreate"),
          headerTooltip: this.$t("common.gridColumns.dateCreate"),
          field: "datecreate",
          tooltipField: "datecreate",
          comparator: (date1, date2) =>
            parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
            parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
        },
        {
          headerName: this.$t("common.gridColumns.dateClose"),
          headerTooltip: this.$t("common.gridColumns.dateClose"),
          field: "dateclose",
          tooltipField: "dateclose",
          comparator: (date1, date2) =>
            parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
            parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
        },
        {
          headerName: this.$t("common.gridColumns.arch"),
          headerTooltip: this.$t("common.gridColumns.arch"),
          field: "narch",
          tooltipField: "narch",
          comparator: (value1, value2) =>
            parseFloat(value1) - parseFloat(value2)
        },
        {
          headerName: this.$t("common.gridColumns.postIndex"),
          headerTooltip: this.$t("common.gridColumns.postIndex"),
          field: "postindex",
          tooltipField: "postindex"
        },
        {
          headerName: this.$t("common.gridColumns.countRoom"),
          headerTooltip: this.$t("common.gridColumns.countRoom"),
          field: "countroom",
          tooltipField: "countroom",
          comparator: (value1, value2) =>
            parseFloat(value1) - parseFloat(value2)
        },
        {
          headerName: this.$t("common.gridColumns.partyHouse"),
          headerTooltip: this.$t("common.gridColumns.partyHouse"),
          field: "partyhouse",
          tooltipField: "partyhouse",
          comparator: (value1, value2) =>
            parseFloat(value1) - parseFloat(value2)
        },
        {
          headerName: this.$t("common.gridColumns.floor"),
          headerTooltip: this.$t("common.gridColumns.floor"),
          field: "floor",
          tooltipField: "floor",
          comparator: (value1, value2) =>
            parseFloat(value1) - parseFloat(value2)
        }
      ],
      countersColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.topIndex"),
          headerTooltip: this.$t("common.gridColumns.topIndex"),
          field: "topindex",
          tooltipField: "topindex",
          editable: params => {
            return this.isDolg ||
              this.paymentFormIsDel ||
              params.data.type === "0"
              ? false
              : true;
          },
          singleClickEdit: true,
          cellEditor: "numericEditor",
          cellClass: params => {
            return params.data.type === "1" ? "editable-column" : "";
          }
        },
        {
          headerName: this.$t("common.gridColumns.service"),
          headerTooltip: this.$t("common.gridColumns.service"),
          field: "service",
          tooltipField: "service"
        },
        {
          headerName: this.$t("common.gridColumns.zone"),
          headerTooltip: this.$t("common.gridColumns.zone"),
          field: "zone",
          tooltipField: "zone"
        },
        {
          headerName: this.$t("common.gridColumns.reading"),
          headerTooltip: this.$t("common.gridColumns.reading"),
          field: "reading",
          tooltipField: "reading",
          cellClass: ["sum-column", "editable-column"],
          editable: () => {
            return this.isDolg || this.paymentFormIsDel ? false : true;
          },
          singleClickEdit: true,
          cellEditor: "numericEditor"
        },
        {
          headerName: this.$t("common.gridColumns.status"),
          headerTooltip: this.$t("common.gridColumns.status"),
          field: "status",
          cellClass: "editable-column",
          tooltipValueGetter: params =>
            params.value === "1"
              ? this.$t("common.types.processed.yes")
              : this.$t("common.types.processed.no"),
          cellRenderer: params => {
            if (this.isDolg || this.paymentFormIsDel) {
              return params.value === "1"
                ? "<input type=checkbox checked disabled>"
                : "<input type=checkbox disabled>";
            } else {
              const input = document.createElement("input");
              input.type = "checkbox";
              input.checked = params.value === "1" ? true : false;
              input.addEventListener("click", () => {
                this.lastRowCounters = params.data.id;

                const payload = {
                  id: params.data.id,
                  newStatus: params.value === "1" ? "0" : "1"
                };
                this.changeStatusPaymentCounters(payload);
              });
              return input;
            }
          }
        }
      ],
      paymentModalVisible: false,
      paymentAbcodeFound: true,
      paymentNotify: null,
      paymentActiveTabName: "",
      paymentForm: {
        abcode: "",
        abcodeOld: "",
        fullName: "",
        address: "",
        dateBegin: "",
        dateEnd: "",
        npack: "",
        datePay: "",
        dateBank: "",
        sumPay: 0,
        kindpay: "",
        kindpayCode: null,
        note: "",
        numPayDoc: "",
        codepurpPayCode: null,
        purpPayCode: null,
        codestatusPayCode: null,
        statusPayCode: null,
        act: false,
        actDisabled: true,
        actId: "",
        actNote: "",
        datePayFrom: "",
        datePayTo: "",
        sumPayMust: 0,
        dateSaveReadings: "",
        dateSaveReadingsOld: "",
        ncount: "",
        perekrutFact: "",
        counter: "",
        perekrutCalc: "",
        readingInput: "",
        readingDiff: "",
        dateReading: "",
        prim: "",
        payId: "",
        payInfoId: "",
        groupСntId: "",
        nop: "",
        tskey: "",
        accountPay: "",
        codefirme: "",
        codefirmeCode: null
      },
      paymentRules: {
        datePay: [
          {
            required: true,
            validator: validateDatePay,
            trigger: "blur"
          }
        ],
        purpPayCode: [
          {
            required: true,
            validator: validatePurpPayCode,
            trigger: "blur"
          }
        ],
        sumPay: [
          {
            required: true,
            validator: validateSumPay,
            trigger: "blur"
          }
        ],
        datePayFrom: [
          {
            required: true,
            validator: validateDatePayFrom,
            trigger: "blur"
          }
        ]
      },
      searchSubscribersModal: false,
      searchSubscribersForm: {
        fullName: "",
        fullNameTypeSearch: "1",
        codestreetCode: null,
        streetCode: null,
        nHouse: 0,
        charHouse: "",
        corpHouse: "",
        nFlat: 0,
        charFlat: "",
        ncount: "",
        ncountTypeSearch: "1",
        plombNumber: "",
        plombNumberTypeSearch: "1",
        docnumber: "",
        docnumberTypeSearch: "1",
        eic: "",
        eicTypeSearch: "1",
        abcode: "",
        abcodeTypeSearch: "1",
        dateBegin: "",
        dateEnd: "",
        codedistrictCode: null,
        districtCode: null,
        actNumber: "",
        actNumberTypeSearch: "1",
        individualFullName: "",
        individualFullNameTypeSearch: "1",
        requestId: 0,
        accountNumber: 0,
        contractNumber: "",
        contractNumberTypeSearch: "1",
        phoneNumber: "",
        phoneNumberTypeSearch: "1",
        houseAccountNumber: "",
        houseAccountNumberTypeSearch: "1"
      },
      searchSubscribersRules: {},
      extendedSearch: false,
      searchTypesOptions: [
        {
          value: "0",
          label: this.$t("common.options.searchTypes.matches")
        },
        {
          value: "1",
          label: this.$t("common.options.searchTypes.contains")
        },
        {
          value: "2",
          label: this.$t("common.options.searchTypes.startsOn")
        },
        {
          value: "3",
          label: this.$t("common.options.searchTypes.endsOn")
        }
      ],
      searchResultsModal: false,
      searchResultsRowCount: 0,
      submitSearchResultsBtnDisabled: false,
      currentSearchResultsRowSelected: null,
      currentCountersRowSelected: null,
      lastEditCountersTopIndex: null,
      lastEditCountersReading: null,
      lastRowCounters: null,
      paymentInfo: "",
      paymentSubmitInfo: "",
      paymentFormAddBtn: false,
      currentCountPay: 0,
      paymentSubmitType: "",
      paymentFormSumPayDisabled: true,
      currentSumPay: 0,
      aboutClientBtnDisabled: true,
      subscriberInfo: "",
      previousAbcode: ""
    };
  },
  computed: {
    ...mapGetters([
      "paymentModal",
      "paymentSubscriber",
      "paymentSubscribers",
      "paymentActs",
      "paymentCounters",
      "paymentCountersClearGroupCntId",
      "paymentData",
      "paymentCheck",
      "paymentOneError",
      "paymentDelError",
      "paymentEdit",
      "paymentSubmit",
      "subscriberCardModal",
      "isCountbandPayment",
      "countbandPaymentType",
      "countbandPaymentTitle",
      "countbandPaymentAmount",
      "countbandPaymentNop",
      "oneCountbandPayment",
      "params"
    ]),
    paymentFormType: function() {
      return ["88", "91", "99", "100"].includes(this.paymentForm.kindpay);
    },
    paymentFormIsEditDel: function() {
      const { state } = this.paymentData;
      return (
        (state === "edit" && !this.isCountbandPayment) ||
        (state === "del" && !this.isCountbandPayment)
      );
    },
    paymentFormIsDel: function() {
      return this.paymentData.state === "del";
    },
    isDolg: function() {
      return this.params.goptions.dolg === "1";
    },
    paymentFormTitle: function() {
      return this.isCountbandPayment
        ? this.countbandPaymentTitle
        : this.$t("payment.paymentForm.modal.title");
    },
    isEditMassInput: function() {
      return (
        this.isCountbandPayment &&
        this.paymentData.state === "edit" &&
        this.paymentForm.actId !== ""
      );
    },
    isSumPayMustDisabled: function() {
      return this.isCountbandPayment ? false : true;
    }
  },
  watch: {
    paymentModal: function(value) {
      this.paymentModalVisible = value;
    },
    paymentModalVisible: function(value) {
      this.setPaymentModal(value);
    },
    paymentSubscriber: async function(value) {
      if (value.length > 0) {
        const res = value[0];

        this.paymentForm.abcode = res.abcode;
        this.paymentForm.fullName = res.fio;
        this.paymentForm.address = res.address;
        this.paymentForm.dateBegin = res.datecreate;
        this.paymentForm.dateEnd = res.dateclose;

        this.paymentAbcodeFound = true;
        this.aboutClientBtnDisabled = false;
      } else {
        // this.paymentForm.abcode = "";
        this.paymentForm.fullName = "";
        this.paymentForm.address = "";
        this.paymentForm.dateBegin = "";
        this.paymentForm.dateEnd = "";

        this.paymentAbcodeFound = false;
        this.aboutClientBtnDisabled = true;

        this.customClearPaymentCounters();
      }

      if (this.paymentForm.dateSaveReadings) {
        this.lastRowCounters = null;

        const {
          abcode,
          abcodeOld,
          dateSaveReadingsOld,
          dateSaveReadings,
          groupСntId
        } = this.paymentForm;

        this.customClearPaymentCounters();
        await this.getPaymentCounters({
          abcode,
          abcodeOld,
          dateSaveReadingsOld,
          dateSaveReadings,
          groupСntId
        });
      }

      await this.loadPaymentActs();
    },
    "searchSubscribersForm.streetCode": function(value) {
      this.searchSubscribersForm.codestreetCode = +value || null;
    },
    "searchSubscribersForm.districtCode": function(value) {
      this.searchSubscribersForm.codedistrictCode = +value || null;
    },
    "paymentForm.purpPayCode": function(value) {
      this.paymentForm.codepurpPayCode = +value || null;

      if (value) {
        const statuspays = this.params.codepay.data.filter(
          item => item.codeplat === value
        );
        if (
          statuspays.length > 0 &&
          statuspays[0].inact === "1" &&
          !this.paymentFormType
        ) {
          this.paymentForm.actDisabled = false;
        } else {
          this.paymentForm.act = false;
          this.paymentForm.actDisabled = true;
        }
      } else {
        this.paymentForm.act = false;
        this.paymentForm.actDisabled = true;
      }
    },
    "paymentForm.statusPayCode": function(value) {
      this.paymentForm.codestatusPayCode = +value || null;
    },
    paymentCheck: function(value) {
      if (value) {
        const { state } = this.paymentData;

        const {
          abcode,
          npack,
          datePay,
          purpPayCode,
          statusPayCode,
          numPayDoc,
          sumPay,
          sumPayMust,
          dateSaveReadings,
          datePayFrom,
          datePayTo,
          actId,
          actNote,
          payId,
          payInfoId,
          groupСntId,
          tskey,
          prim,
          nop
        } = this.paymentForm;

        const datebegin = this.paymentFormType ? datePayFrom : "";
        const dateend = this.paymentFormType
          ? datePayTo
          : dateSaveReadings || "";

        if (value.type === "ok") {
          if (state === "add") {
            this.clearPaymentSubmit();
            this.getPaymentSubmit({
              abcode,
              npack,
              dateclient: datePay,
              codeplat: purpPayCode,
              coderr: statusPayCode,
              paynum: numPayDoc,
              summpay: sumPay || 0,
              summpayreq: sumPayMust || 0,
              datebegin,
              dateend,
              actid: actId,
              mess: actNote,
              dateSaveReadings: dateSaveReadings || ""
            });
          } else if (state === "edit") {
            this.clearPaymentEdit();

            // для редактирования платежей в массовом вводе
            if (this.isCountbandPayment) {
              this.getMVPaymentEdit({
                abcode,
                dateclient: datePay,
                summpay: sumPay || 0,
                paynum: numPayDoc,
                codeplat: purpPayCode,
                coderr: statusPayCode || "0",
                datebegin,
                dateend: dateend || "",
                summpayreq: sumPayMust || 0,
                actid: actId,
                actprim: actNote,
                groupcntid: groupСntId,
                nop,
                tskey,
                dateSaveReadings: dateSaveReadings || ""
              });
            } else {
              this.getPaymentEdit({
                payid: payId,
                paynum: numPayDoc,
                dateclient: datePay,
                groupcntid: groupСntId,
                codeplat: purpPayCode,
                coderr: statusPayCode || "0",
                datebegin,
                dateend: dateend || "",
                payinfoid: payInfoId,
                abcode,
                prim,
                tskey,
                dateSaveReadings: dateSaveReadings || ""
              });
            }
          }
        } else if (value.type === "error") {
          let message = "";
          if (value.errormess.length === 1) {
            message = value.errormess[0];
          } else {
            message = value.errormess.join("<br />");
          }

          this.$alert(message, this.$t("common.errors.title"), {
            confirmButtonText: "OK",
            type: "error",
            dangerouslyUseHTMLString: true
          });
        } else if (value.type === "qa") {
          this.$confirm(value.question, this.$t("common.errors.warning"), {
            confirmButtonText: this.$t("common.buttons.confirmYes"),
            cancelButtonText: this.$t("common.buttons.confirmNo"),
            cancelButtonClass: "cancel-button",
            type: "warning"
          })
            .then(() => {
              this.$alert(value.answer, this.$t("common.errors.warning"), {
                confirmButtonText: "OK",
                type: "warning",
                dangerouslyUseHTMLString: true
              });
            })
            .catch(() => {
              if (state === "add") {
                this.clearPaymentSubmit();
                this.getPaymentSubmit({
                  abcode,
                  npack,
                  dateclient: datePay,
                  codeplat: purpPayCode,
                  coderr: statusPayCode,
                  paynum: numPayDoc,
                  summpay: sumPay || 0,
                  summpayreq: sumPayMust || 0,
                  datebegin,
                  dateend,
                  actid: actId,
                  mess: actNote,
                  dateSaveReadings: dateSaveReadings || ""
                });
              } else if (state === "edit") {
                this.clearPaymentEdit();
                this.getPaymentEdit({
                  payid: payId,
                  paynum: numPayDoc,
                  dateclient: datePay,
                  groupcntid: groupСntId,
                  codeplat: purpPayCode,
                  coderr: statusPayCode || "0",
                  datebegin,
                  dateend: dateend || "",
                  payinfoid: payInfoId,
                  abcode,
                  prim,
                  tskey,
                  dateSaveReadings: dateSaveReadings || ""
                });
              }
            });
        }
      }
    },
    paymentOneError: async function(value) {
      if (value.data.length > 0) {
        const res = value.data[0];

        this.paymentForm.abcode = res.abcode;
        this.paymentForm.prim = res.prim;
        this.paymentForm.datePay = res.dateclient;
        this.paymentForm.dateBank = res.datebank;
        this.paymentForm.sumPay = $(res.summpay).toNumber();
        this.paymentForm.numPayDoc = res.paynum;
        this.paymentForm.kindpayCode = $(res.kindpay).toNumber();
        this.paymentForm.kindpay = res.kindpay;
        this.paymentForm.codefirmeCode = $(res.codefirme).toNumber();
        this.paymentForm.codefirme = res.codefirme;
        this.paymentForm.accountPay = res.rcount;
        this.paymentForm.codepurpPayCode = $(res.codeplat).toNumber();
        this.paymentForm.purpPayCode = res.codeplat;
        this.paymentForm.codestatusPayCode = $(res.coderr).toNumber();
        this.paymentForm.statusPayCode = res.coderr;

        this.paymentForm.payId = res.payid;
        this.paymentForm.payInfoId = res.payinfoid;
        this.paymentForm.groupСntId = res.groupcntid;
        this.paymentForm.tskey = res.tskey;

        if (this.paymentFormType) {
          this.paymentForm.datePayFrom = res.datebegin;
          this.paymentForm.datePayTo = res.dateend;
          this.paymentForm.sumPayMust = $(res.summpayreq).toNumber();
        } else {
          this.paymentForm.dateSaveReadings = res.dateend;
        }

        this.setPaymentCountersInit(true);
        await this.paymentFormAbcodeSearch();
      }
    },
    paymentDelError: function(value) {
      if (value) {
        this.$alert(value.message, "", {
          confirmButtonText: "OK",
          type: value.type,
          callback: () => {
            if (value.type !== "error") {
              this.paymentModalVisible = false;

              const payload = {
                type: "del",
                newPayId: "",
                statusPay: ""
              };
              this.setPaymentRefreshErrors(payload);
            }
          }
        });
      }
    },
    paymentEdit: function(value) {
      if (value) {
        this.paymentModalVisible = false;

        // для редактирования платежей в массовом вводе и остальных случаях
        if (this.isCountbandPayment) {
          this.clearPaymentSubmit();
          const payload = {
            data: value.data
          };
          this.setPaymentSubmit(payload);
        } else {
          const payload = {
            type: "edit",
            newPayId: value.data,
            statusPay: value.statuspay
          };
          this.setPaymentRefreshErrors(payload);
        }
      }
    },
    paymentSubmit: function(value) {
      if (value) {
        if (this.paymentSubmitType === "submit") {
          this.paymentModalVisible = false;
        } else if (this.paymentSubmitType === "add") {
          const { npack, date, kindpay, note } = this.paymentData;

          this.currentSumPay = $(this.currentSumPay)
            .minus($(this.paymentForm.sumPay))
            .toNumber();
          this.currentSumPay = this.currentSumPay < 0 ? 0 : this.currentSumPay;

          this.paymentForm = {
            abcode: "",
            abcodeOld: "",
            fullName: "",
            address: "",
            dateBegin: "",
            dateEnd: "",
            npack: "",
            datePay: "",
            dateBank: "",
            sumPay: 0,
            kindpay: "",
            kindpayCode: null,
            note: "",
            numPayDoc: "",
            codepurpPayCode: null,
            purpPayCode: null,
            codestatusPayCode: null,
            statusPayCode: null,
            act: false,
            actDisabled: true,
            actId: "",
            actNote: "",
            datePayFrom: "",
            datePayTo: "",
            sumPayMust: 0,
            dateSaveReadings: "",
            dateSaveReadingsOld: "",
            ncount: "",
            perekrutFact: "",
            counter: "",
            perekrutCalc: "",
            readingInput: "",
            readingDiff: "",
            dateReading: "",
            prim: "",
            payId: "",
            payInfoId: "",
            groupСntId: "",
            nop: "",
            tskey: "",
            accountPay: "",
            codefirme: "",
            codefirmeCode: null
          };

          this.clearPaymentActs();
          this.clearPaymentCounters();

          this.paymentForm.codepurpPayCode = $(
            this.params.goptions.defaultcodeplat
          ).toNumber();
          this.paymentForm.purpPayCode =
            this.params.goptions.defaultcodeplat || "";
          this.paymentForm.codestatusPayCode = 0;
          this.paymentForm.statusPayCode = "0";
          this.paymentForm.npack = npack;
          this.paymentForm.datePay = date;
          this.paymentForm.dateBank = date;
          this.paymentForm.sumPay = this.currentSumPay;
          this.paymentForm.kindpay = kindpay;
          this.paymentForm.note = note;

          this.currentCountPay -= 1;
          if (this.currentCountPay === 1) {
            this.paymentFormAddBtn = false;
          }
        }
      }
    },
    oneCountbandPayment: async function(value) {
      if (value.data.length > 0) {
        const res = value.data[0];

        this.previousAbcode = res.abcode;

        this.paymentForm.abcode = res.abcode;
        this.paymentForm.datePay = res.dateclient;
        this.paymentForm.dateBank = res.datebank;
        this.paymentForm.sumPay = $(res.summpay).toNumber();
        this.paymentForm.numPayDoc = res.paynum;
        this.paymentForm.codepurpPayCode = $(res.codeplat).toNumber();
        this.paymentForm.purpPayCode = res.codeplat;
        this.paymentForm.codestatusPayCode = $(res.coderr).toNumber();
        this.paymentForm.statusPayCode = res.coderr;

        // акт id и примечание по акту (массовый ввод)
        this.paymentForm.actId = res.actid;
        this.paymentForm.actNote = res.actprim;

        // если к платежу привязан акт, то активировать галку Акт по умолчанию (массовый ввод)
        this.paymentForm.act = res.actid ? true : false;

        this.paymentForm.groupСntId = res.groupcntid;
        this.paymentForm.nop = res.nop;
        this.paymentForm.tskey = res.tskey;

        if (this.paymentFormType) {
          this.paymentForm.datePayFrom = res.datebegin;
          this.paymentForm.datePayTo = res.dateend;
          this.paymentForm.sumPayMust = $(res.summpayreq).toNumber();
        } else {
          this.paymentForm.dateSaveReadings = res.dateend;
        }

        this.setPaymentCountersInit(true);
        await this.paymentFormAbcodeSearch();
      }
    },
    "paymentForm.abcode": function(value, oldValue) {
      this.paymentForm.abcodeOld = oldValue;
    },
    paymentCountersClearGroupCntId: function(value) {
      if (value === "1") {
        this.paymentForm.groupСntId = "";
      }
    }
  },
  created() {
    this.paymentActiveTabName = "pay";
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.searchResultsGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.countersGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.countersGetRowStyle = params => {
      if (params.data.color === "1") return { color: "red" };
    };

    this.countersFrameworkComponents = {
      numericEditor: NumericEditor
    };
  },
  methods: {
    ...mapMutations([
      "setPaymentModal",
      "clearPaymentSubscriberSearch",
      "clearPaymentSubscribersSearch",
      "setPaymentSubscriberSearch",
      "clearPaymentActs",
      "clearPaymentCounters",
      "smartClearPaymentCounters",
      "customClearPaymentCounters",
      "addPaymentCounters",
      "deleteFactualPaymentCounters",
      "deleteAbstrctPaymentCounters",
      "deleteNonexistPaymentCounters",
      "changeOneTopindexPaymentCounters",
      "changeManyTopindexPaymentCounters",
      "changeReadingPaymentCounters",
      "clearPaymentCheck",
      "clearPaymentSubmit",
      "clearPaymentData",
      "changeStatusPaymentCounters",
      "clearPaymentOneError",
      "clearPaymentDelError",
      "setPaymentCountersInit",
      "setPaymentRefreshErrors",
      "clearPaymentEdit",
      "setSubscriberCardModal",
      "setGridContextMenuModal",
      "setGridContextMenuKey",
      "setGridContextMenuEvent",
      "clearCountbandPayment",
      "clearOneCountbandPayment",
      "setPaymentSubmit",
      "clearPaymentSubmit",
      "setError"
    ]),
    ...mapActions([
      "paymentSubscriberSearch",
      "paymentSubscribersSearch",
      "getPaymentActs",
      "getPaymentCounters",
      "getPaymentCheck",
      "getPaymentSubmit",
      "getPaymentEdit",
      "getMVPaymentEdit",
      "getPaymentOneError",
      "getPaymentDelError",
      "getOneCountbandPayment"
    ]),
    onGridSizeChanged(params) {
      // params.api.sizeColumnsToFit();
    },
    onSearchResultsGridReady(params) {
      this.searchResultsGridApi = params.api;
      this.searchResultsColumnApi = params.columnApi;
    },
    onSearchResultsFirstDataRendered(event) {
      setGridView("wb-payment-grid-subscribers", event, "full");
    },
    onSearchResultsRowRightClicked(event) {
      this.setGridContextMenuKey("wb-payment-grid-subscribers");
      this.setGridContextMenuEvent(event);
      this.setGridContextMenuModal(true);
    },
    onSearchResultsModelUpdated(params) {
      this.searchResultsRowCount = params.api.getDisplayedRowCount();

      this.submitSearchResultsBtnDisabled =
        this.searchResultsRowCount === 0 ? true : false;

      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
      // params.api.sizeColumnsToFit();
    },
    onSearchResultsRowSelected(params) {
      if (params.node.selected) {
        this.currentSearchResultsRowSelected = params.node.data;
      }
    },
    onSearchResultsRowDoubleClicked() {
      this.searchResultsModalSubmit();
    },
    onCountersGridReady(params) {
      this.countersGridApi = params.api;
      this.countersColumnApi = params.columnApi;
    },
    onCountersFirstDataRendered(event) {
      setGridView("wb-payment-grid-counters", event, "optimal");
    },
    onCountersRowRightClicked(event) {
      this.setGridContextMenuKey("wb-payment-grid-counters");
      this.setGridContextMenuEvent(event);
      this.setGridContextMenuModal(true);
    },
    onCountersModelUpdated(params) {
      this.paymentForm.ncount = "";
      this.paymentForm.perekrutFact = "";
      this.paymentForm.counter = "";
      this.paymentForm.perekrutCalc = "";
      this.paymentForm.readingInput = "";
      this.paymentForm.readingDiff = "";

      params.api.forEachNode(node => {
        if (this.lastRowCounters) {
          node.setSelected(node.data.id === this.lastRowCounters);
        } else {
          node.rowIndex ? 0 : node.setSelected(true);
        }
      });
      params.api.sizeColumnsToFit();
    },
    onCountersRowSelected(params) {
      if (params.node.selected) {
        this.currentCountersRowSelected = params.node.data;

        const {
          scale,
          dateval,
          ncount,
          perekrut,
          counter,
          reading,
          type
        } = this.currentCountersRowSelected;

        this.paymentForm.dateReading = dateval;
        this.paymentForm.ncount = ncount;
        this.paymentForm.perekrutFact = perekrut;
        this.paymentForm.counter = counter.padStart(+scale, "0");
        this.paymentForm.perekrutCalc = perekrut;

        const readingCalc = reading || "0";
        this.paymentForm.readingInput = scale
          ? readingCalc.padStart(+scale, "0")
          : readingCalc;

        const readingNumber = Number(reading);
        const counterNumber = Number(counter);
        let readingDiff;
        let perekrutNeeded = false;

        if (reading) {
          if (readingNumber === 0) {
            perekrutNeeded = true;
            readingDiff = 0;
          } else {
            const scaleNumber =
              readingNumber < counterNumber
                ? Number("1".padEnd(Number(scale) + 1, "0"))
                : 0;
            readingDiff =
              Number(scaleNumber) + Number(reading) - Number(counter);

            if (scaleNumber !== 0) perekrutNeeded = true;
          }
        } else {
          readingDiff = 0;
        }

        if (perekrutNeeded && type === "0") {
          let perekrutNumber = Number(perekrut);
          perekrutNumber++;
          this.paymentForm.perekrutCalc = perekrutNumber.toString();
        }

        this.paymentForm.readingDiff = readingDiff
          .toString()
          .padStart(+scale, "0");
      }
    },
    onCountersCellEditingStarted(params) {
      if (params.column.colId === "topindex") {
        this.lastEditCountersTopIndex = params.value;
      } else if (params.column.colId === "reading") {
        this.lastEditCountersReading = params.value;
      }
    },
    onCountersCellEditingStopped(params) {
      if (params.column.colId === "topindex") {
        if (isNaN(Number(params.value))) {
          this.countersGridOptions.api.undoCellEditing();
          return;
        }

        if (this.lastEditCountersTopIndex !== params.value) {
          const counters = this.paymentCounters.filter(
            item => item.topindex === params.value
          );
          if (counters.length > 1) {
            this.countersGridOptions.api.undoCellEditing();
            this.$alert(
              this.$t("common.errors.pointAlreadyExists"),
              this.$t("common.errors.title"),
              {
                confirmButtonText: "OK",
                type: "error"
              }
            );
          } else {
            this.lastRowCounters = params.data.id;

            const payloadId = {
              id: params.data.id,
              newValue: params.value
            };
            this.changeOneTopindexPaymentCounters(payloadId);

            const payloadValue = {
              oldValue: this.lastEditCountersTopIndex,
              newValue: params.value
            };
            this.changeManyTopindexPaymentCounters(payloadValue);
          }
        }
      } else if (params.column.colId === "reading") {
        if (isNaN(Number(params.value))) {
          this.countersGridOptions.api.undoCellEditing();
          return;
        }

        this.lastRowCounters = params.data.id;

        const payload = {
          id: params.data.id,
          // oldReading: this.lastEditCountersReading,
          newReading: params.value ? Number(params.value).toString() : ""
        };
        this.changeReadingPaymentCounters(payload);
      }
    },
    onAbcodeChange(event) {
      if (this.isEditMassInput) {
        this.paymentForm.abcode = this.previousAbcode;
        this.showEditMassInputAlert();
      } else {
        this.paymentFormAbcodeSearch();
      }
    },
    onDateSaveReadingsChanged() {
      if (this.paymentForm.dateSaveReadings) {
        const dateStart = this.$moment(
          this.paymentForm.dateSaveReadings,
          "DD.MM.YYYY"
        );
        const dateEnd = this.$moment(this.paymentForm.datePay, "DD.MM.YYYY");

        const dateDiff = Math.abs(
          Math.round(this.$moment.duration(dateStart.diff(dateEnd)).asDays())
        );
        const maxDateDiff = Number(this.params.goptions.maxdatediff);

        if (!Number.isNaN(maxDateDiff) && dateDiff > maxDateDiff) {
          this.$alert(
            this.$t("common.errors.payDateDiff"),
            this.$t("common.errors.warning"),
            {
              confirmButtonText: "OK",
              type: "info"
            }
          );
        }

        if (this.paymentForm.abcode) {
          this.lastRowCounters = null;

          const {
            abcode,
            abcodeOld,
            dateSaveReadings,
            dateSaveReadingsOld,
            groupСntId
          } = this.paymentForm;

          // this.smartClearPaymentCounters();
          this.getPaymentCounters({
            abcode,
            abcodeOld,
            dateSaveReadingsOld,
            dateSaveReadings,
            groupСntId
          });

          this.paymentForm.dateSaveReadingsOld = this.paymentForm.dateSaveReadings;
        }
      } else {
        this.smartClearPaymentCounters();
      }
    },
    onClickPaymentNote() {
      if (!this.paymentNotify) {
        this.paymentNotify = this.$notify({
          title: `${this.$t("common.errors.note")}`,
          message: this.paymentForm.note,
          duration: 0,
          position: "top-left",
          onClose: () => {
            this.paymentNotify = null;
          }
        });
      } else {
        this.paymentNotify.close();
      }
    },
    onPaymentActiveTabClick(tab) {
      // if (tab.name === "act") {
      //   this.loadPaymentActs();
      // }
    },
    loadPaymentActs() {
      const abcode = this.paymentForm.abcode;

      if (!this.isCountbandPayment) {
        this.paymentForm.actId = "";
        this.paymentForm.actNote = "";
      }

      this.clearPaymentActs();
      this.getPaymentActs({ abcode });
    },
    infoAbstractReadings() {
      this.$alert(
        this.$t("common.errors.readingNotBeCalc"),
        this.$t("common.errors.warning"),
        {
          confirmButtonText: "OK",
          type: "info"
        }
      );
    },
    getAbstractReadings() {
      return {
        id: this.$uuid.v4(),
        scale: "",
        zoneheadid: "",
        nametypecount: "",
        ncount: "",
        codeservice: "",
        topid: "",
        dateval: "",
        perekrut: "0",
        topindex: "",
        zoneindex: "",
        counter: "0",
        status: "1",
        type: "1",
        color: "1",
        reading: "",
        paycntid: "",
        behaviorstatus: "add"
      };
    },
    calcNextTopindex() {
      const maxItem = this.paymentCounters.reduce(
        (prev, cur) => (+cur.topindex > +prev.topindex ? cur : prev),
        { topindex: 0 }
      );
      let maxTopindex = +maxItem.topindex;
      return `${++maxTopindex}`;
    },
    onAddOneZoneAbstractReadingsBtn() {
      this.infoAbstractReadings();

      const calcIndex = this.calcNextTopindex();

      const payload = this.getAbstractReadings();
      payload.topindex = calcIndex;
      this.addPaymentCounters(payload);
    },
    onAddTwoZoneAbstractReadingsBtn() {
      this.infoAbstractReadings();

      const calcIndex = this.calcNextTopindex();

      const payload1 = this.getAbstractReadings();
      payload1.topindex = calcIndex;
      payload1.zoneheadid = "1";
      payload1.zoneindex = "1";
      this.addPaymentCounters(payload1);

      const payload2 = this.getAbstractReadings();
      payload2.topindex = calcIndex;
      payload2.zoneheadid = "1";
      payload2.zoneindex = "2";
      this.addPaymentCounters(payload2);
    },
    onAddThreeZoneAbstractReadingsBtn() {
      this.infoAbstractReadings();

      const calcIndex = this.calcNextTopindex();

      const payload1 = this.getAbstractReadings();
      payload1.topindex = calcIndex;
      payload1.zoneheadid = "2";
      payload1.zoneindex = "1";
      this.addPaymentCounters(payload1);

      const payload2 = this.getAbstractReadings();
      payload2.topindex = calcIndex;
      payload2.zoneheadid = "2";
      payload2.zoneindex = "2";
      this.addPaymentCounters(payload2);

      const payload3 = this.getAbstractReadings();
      payload3.topindex = calcIndex;
      payload3.zoneheadid = "2";
      payload3.zoneindex = "3";
      this.addPaymentCounters(payload3);
    },
    onDeleteAbstractReadingsBtn() {
      const { topindex, type } = this.currentCountersRowSelected;

      switch (type) {
        case "0":
          this.deleteFactualPaymentCounters(topindex);
          break;
        case "1":
          this.deleteAbstrctPaymentCounters(topindex);
          break;
        case "2":
          this.deleteNonexistPaymentCounters(topindex);
          break;
      }
    },
    paymentModalShow() {
      this.paymentForm.purpPayCode = this.params.goptions.defaultcodeplat || "";
      this.paymentForm.statusPayCode = "0";

      const {
        state,
        npack,
        payid,
        date,
        sumPay,
        kindpay,
        countpay,
        note
      } = this.paymentData;

      switch (state) {
        case "add":
          this.paymentInfo = this.$t("payment.paymentForm.info.add");
          this.paymentSubmitInfo = this.$t("common.buttons.submit");

          this.paymentForm.npack = npack;
          this.paymentForm.datePay = date;
          this.paymentForm.dateBank = date;
          this.paymentForm.sumPay = sumPay;
          this.paymentForm.kindpay = kindpay;
          this.paymentForm.note = note;

          // расчет доступности редактирования поля "Сумма платежа"
          // при создании платежа в массовом вводе и в остальных случаях
          if (this.isCountbandPayment) {
            this.paymentFormAddBtn =
              parseInt(this.countbandPaymentAmount) + 1 >= parseInt(countpay)
                ? false
                : true;
            this.paymentFormSumPayDisabled = false;
          } else {
            this.paymentFormAddBtn = parseInt(countpay) > 1 ? true : false;
            this.paymentFormSumPayDisabled =
              parseInt(countpay) > 1 ? false : true;
          }

          this.currentCountPay = parseInt(countpay);
          this.currentSumPay = sumPay;
          break;
        case "edit":
          this.paymentInfo = this.$t("payment.paymentForm.info.edit");
          this.paymentSubmitInfo = this.$t("common.buttons.submit");

          // получение данных для редактирования в режиме массового ввода и в остальных случаях
          if (this.isCountbandPayment) {
            this.paymentForm.kindpay = kindpay;
            this.paymentFormSumPayDisabled = false;

            const nop = this.countbandPaymentNop;

            this.clearOneCountbandPayment();
            this.getOneCountbandPayment({ nop });
          } else {
            this.clearPaymentOneError();
            this.getPaymentOneError({
              perror: "1",
              payid
            });
          }
          break;
        case "del":
          this.paymentInfo = this.$t("payment.paymentForm.info.del");
          this.paymentSubmitInfo = this.$t("common.buttons.refund");

          this.clearPaymentOneError();
          this.getPaymentOneError({
            perror: "1",
            payid
          });
          break;
      }
    },
    paymentModalHide() {
      this.$refs.payment.scrollTo(0, 0);
      // this.$refs.payment.resetFields();

      this.paymentForm = {
        abcode: "",
        abcodeOld: "",
        fullName: "",
        address: "",
        dateBegin: "",
        dateEnd: "",
        npack: "",
        datePay: "",
        dateBank: "",
        sumPay: 0,
        kindpay: "",
        kindpayCode: null,
        note: "",
        numPayDoc: "",
        codepurpPayCode: null,
        purpPayCode: null,
        codestatusPayCode: null,
        statusPayCode: null,
        act: false,
        actDisabled: true,
        actId: "",
        actNote: "",
        datePayFrom: "",
        datePayTo: "",
        sumPayMust: 0,
        dateSaveReadings: "",
        dateSaveReadingsOld: "",
        ncount: "",
        perekrutFact: "",
        counter: "",
        perekrutCalc: "",
        readingInput: "",
        readingDiff: "",
        dateReading: "",
        prim: "",
        payId: "",
        payInfoId: "",
        groupСntId: "",
        nop: "",
        tskey: "",
        accountPay: "",
        codefirme: "",
        codefirmeCode: null
      };

      this.paymentAbcodeFound = true;
      this.paymentForm.act = false;
      this.paymentForm.actDisabled = true;
      this.paymentActiveTabName = "pay";
      this.paymentInfo = "";
      this.paymentSubmitInfo = "";
      this.currentCountPay = 0;
      this.paymentFormSumPayDisabled = true;
      this.currentSumPay = 0;
      if (this.paymentNotify) this.paymentNotify.close();

      // this.clearPaymentSubscriberSearch();
      this.clearPaymentActs();
      this.clearPaymentCounters();
      this.clearPaymentData();
      this.clearPaymentOneError();
      this.clearPaymentDelError();
      this.clearCountbandPayment();
      this.setPaymentCountersInit(false);
      this.clearOneCountbandPayment();
    },
    showEditMassInputAlert() {
      this.$alert(
        this.$t("payment.paymentForm.alert.actExistsNoChangeAbcode"),
        "",
        {
          confirmButtonText: this.$t("common.buttons.confirmOk"),
          type: "warning"
        }
      );
    },
    paymentFormSearch() {
      if (this.isEditMassInput) {
        this.showEditMassInputAlert();
      } else {
        this.searchSubscribersModal = true;
      }
    },
    paymentFormAbcodeSearch() {
      if (this.paymentForm.abcode) {
        const abcode = this.paymentForm.abcode;
        this.aboutClientBtnDisabled = false;

        this.paymentSubscriberSearch({ abcode });
      } else {
        // this.paymentForm.abcode = "";
        this.paymentForm.fullName = "";
        this.paymentForm.address = "";
        this.paymentForm.dateBegin = "";
        this.paymentForm.dateEnd = "";

        this.paymentAbcodeFound = true;
        this.aboutClientBtnDisabled = true;

        this.paymentForm.actId = "";
        this.paymentForm.actNote = "";

        this.clearPaymentActs();
        this.customClearPaymentCounters();
      }
    },
    paymentFormAddOrEdit(behaviorstatus) {
      const {
        abcode,
        dateBank,
        sumPay,
        dateSaveReadings,
        kindpay,
        datePayFrom,
        datePayTo
      } = this.paymentForm;

      const typepay = this.paymentFormType ? "2" : "1"; // платежи или субсидии

      this.clearPaymentCheck();
      if (typepay === "1") {
        const codeservice =
          this.paymentCounters.length > 0
            ? this.paymentCounters[0].codeservice
            : "";

        this.getPaymentCheck({
          behaviorstatus,
          abcode,
          datebank: dateBank,
          typepay,
          summpay: sumPay || 0,
          datebegin: "",
          dateend: dateSaveReadings || "",
          codeservice,
          kindpay
        });
      } else if (typepay === "2") {
        this.getPaymentCheck({
          behaviorstatus,
          abcode,
          datebank: dateBank,
          typepay,
          summpay: sumPay || 0,
          datebegin: datePayFrom,
          dateend: datePayTo,
          codeservice: "",
          kindpay
        });
      }
    },
    checkZeroTopIndex() {
      const zeroTopIndex = [
        ...this.paymentCounters.filter(item => item.topindex === "0")
      ];
      return zeroTopIndex.length;
    },
    paymentFormAdd() {
      if (this.currentCountPay > 1) {
        this.$refs.paymentForm.validate(valid => {
          if (valid) {
            this.paymentSubmitType = "add";

            this.paymentFormAddOrEdit("add");
          }
        });
      }
    },
    paymentFormSubmit() {
      this.$refs.paymentForm.validate(valid => {
        if (valid) {
          this.paymentSubmitType = "submit";

          const { state } = this.paymentData;

          if (state === "edit" && this.checkZeroTopIndex() > 0) {
            this.$alert(
              this.$t("payment.paymentForm.alert.pointNumberCannotBeEmpty"),
              this.$t("common.errors.title"),
              {
                confirmButtonText: "OK",
                type: "error"
              }
            );
          } else {
            switch (state) {
              // Добавление платежа
              case "add":
                this.paymentFormAddOrEdit("add");
                break;
              // Исправление платежа
              case "edit":
                this.$confirm(
                  this.$t("payment.paymentForm.alert.modifyCurrentRecord"),
                  "",
                  {
                    confirmButtonText: this.$t("common.buttons.confirmYes"),
                    cancelButtonText: this.$t("common.buttons.confirmNo"),
                    cancelButtonClass: "cancel-button",
                    type: "info"
                  }
                )
                  .then(() => {
                    this.setPaymentRefreshErrors(null);
                    this.paymentFormAddOrEdit("edit");
                  })
                  .catch(() => {});
                break;
              // Возврат платежа
              case "del":
                this.$confirm(
                  this.$t("payment.paymentForm.alert.makeRefund"),
                  "",
                  {
                    confirmButtonText: this.$t("common.buttons.confirmYes"),
                    cancelButtonText: this.$t("common.buttons.confirmNo"),
                    cancelButtonClass: "cancel-button",
                    type: "info"
                  }
                )
                  .then(() => {
                    this.$confirm(
                      this.$t("payment.paymentForm.alert.confirmMakeRefund"),
                      "",
                      {
                        confirmButtonText: this.$t("common.buttons.confirmYes"),
                        cancelButtonText: this.$t("common.buttons.confirmNo"),
                        cancelButtonClass: "cancel-button",
                        type: "info"
                      }
                    )
                      .then(() => {
                        const {
                          payId,
                          numPayDoc,
                          datePay,
                          groupСntId,
                          purpPayCode,
                          statusPayCode,
                          datePayFrom,
                          datePayTo,
                          dateSaveReadings,
                          payInfoId,
                          abcode,
                          prim
                        } = this.paymentForm;

                        this.setPaymentRefreshErrors(null);
                        this.clearPaymentDelError();
                        this.getPaymentDelError({
                          payid: payId,
                          paynum: numPayDoc,
                          dateclient: datePay,
                          groupcntid: groupСntId,
                          codeplat: purpPayCode,
                          coderr: statusPayCode,
                          datebegin: this.paymentFormType ? datePayFrom : "",
                          dateend: this.paymentFormType
                            ? datePayTo
                            : dateSaveReadings,
                          payinfoid: payInfoId,
                          abcode,
                          comment: prim
                        });
                      })
                      .catch(() => {});
                  })
                  .catch(() => {});
                break;
            }
          }
        }
      });
    },
    searchSubscribersModalHide() {
      this.$refs.searchSubscribers.scrollTo(0, 0);
      // this.$refs.searchSubscribersForm.resetFields();
    },
    searchSubscribersFormSubmit() {
      const {
        fullName,
        fullNameTypeSearch,
        streetCode,
        nHouse,
        charHouse,
        corpHouse,
        nFlat,
        charFlat,
        ncount,
        ncountTypeSearch,
        plombNumber,
        plombNumberTypeSearch,
        docnumber,
        docnumberTypeSearch,
        eic,
        eicTypeSearch,
        abcode,
        abcodeTypeSearch,
        dateBegin,
        dateEnd,
        districtCode,
        actNumber,
        actNumberTypeSearch,
        individualFullName,
        individualFullNameTypeSearch,
        requestId,
        accountNumber,
        contractNumber,
        contractNumberTypeSearch,
        phoneNumber,
        phoneNumberTypeSearch,
        houseAccountNumber,
        houseAccountNumberTypeSearch
      } = this.searchSubscribersForm;

      const compactSearchValidation =
        !fullName &&
        !streetCode &&
        nHouse === 0 &&
        !charHouse &&
        !corpHouse &&
        nFlat === 0 &&
        !charFlat &&
        !ncount &&
        !plombNumber;

      const extendedSearchValidation =
        !docnumber &&
        !eic &&
        !abcode &&
        !dateBegin &&
        !dateEnd &&
        !districtCode &&
        !actNumber &&
        !individualFullName &&
        requestId === 0 &&
        accountNumber === 0 &&
        !contractNumber &&
        !phoneNumber &&
        !houseAccountNumber;

      if (
        (!this.extendedSearch && compactSearchValidation) ||
        (this.extendedSearch &&
          compactSearchValidation &&
          extendedSearchValidation)
      ) {
        this.$alert(
          this.$t("common.errors.conditionNotSet"),
          this.$t("common.errors.title"),
          {
            confirmButtonText: "OK",
            type: "warning"
          }
        );
        return;
      }

      const extendedSearch = this.extendedSearch;

      this.searchSubscribersModal = false;
      this.searchResultsModal = true;

      if (this.searchResultsGridOptions.api) {
        this.searchResultsGridOptions.api.setRowData([]);
        this.searchResultsGridOptions.api.showLoadingOverlay();
      }

      this.paymentSubscribersSearch({
        extendedSearch,
        fullName,
        fullNameTypeSearch,
        streetCode,
        nHouse,
        charHouse,
        corpHouse,
        nFlat,
        charFlat,
        ncount,
        ncountTypeSearch,
        plombNumber,
        plombNumberTypeSearch,
        docnumber,
        docnumberTypeSearch,
        eic,
        eicTypeSearch,
        abcode,
        abcodeTypeSearch,
        dateBegin,
        dateEnd,
        districtCode,
        actNumber,
        actNumberTypeSearch,
        individualFullName,
        individualFullNameTypeSearch,
        requestId,
        accountNumber,
        contractNumber,
        contractNumberTypeSearch,
        phoneNumber,
        phoneNumberTypeSearch,
        houseAccountNumber,
        houseAccountNumberTypeSearch
      });
    },
    searchSubscribersFormClear() {
      this.searchSubscribersForm = {
        fullName: "",
        fullNameTypeSearch: "1",
        codestreetCode: null,
        streetCode: null,
        nHouse: 0,
        charHouse: "",
        corpHouse: "",
        nFlat: 0,
        charFlat: "",
        ncount: "",
        ncountTypeSearch: "1",
        plombNumber: "",
        plombNumberTypeSearch: "1",
        docnumber: "",
        docnumberTypeSearch: "1",
        eic: "",
        eicTypeSearch: "1",
        abcode: "",
        abcodeTypeSearch: "1",
        dateBegin: "",
        dateEnd: "",
        codedistrictCode: null,
        districtCode: null,
        actNumber: "",
        actNumberTypeSearch: "1",
        individualFullName: "",
        individualFullNameTypeSearch: "1",
        requestId: 0,
        accountNumber: 0,
        contractNumber: "",
        contractNumberTypeSearch: "1",
        phoneNumber: "",
        phoneNumberTypeSearch: "1",
        houseAccountNumber: "",
        houseAccountNumberTypeSearch: "1"
      };
    },
    searchSubscribersFormHelp() {
      const messages = `
        ${this.$t("payment.searchSubscribersForm.help.message1")}
        ${this.$t("payment.searchSubscribersForm.help.message2")}
        ${this.$t("payment.searchSubscribersForm.help.message3")}
        ${this.$t("payment.searchSubscribersForm.help.message4")}
        ${this.$t("payment.searchSubscribersForm.help.message5")}
        ${this.$t(
          "payment.searchSubscribersForm.help.message6"
        )}                                        
      `;

      this.$alert(messages, this.$t("common.errors.searchSubscribers"), {
        dangerouslyUseHTMLString: true
      });
    },
    searchResultsModalHide() {
      this.clearPaymentSubscribersSearch();
    },
    searchResultsModalSubmit() {
      const payload = {
        data: [],
        rows: 1
      };
      payload.data.push(this.currentSearchResultsRowSelected);
      this.setPaymentSubscriberSearch(payload);
      this.searchResultsModal = false;
    },
    onAboutClientBtn() {
      this.subscriberInfo = `${this.$t("common.address.abcode")} ${
        this.paymentForm.abcode
      }, ${this.paymentForm.fullName}, ${this.$t("common.address.address")} ${
        this.paymentForm.address
      }`;
      this.setSubscriberCardModal(true);
    },
    onChangeCodestreetCode(event) {
      const value = event.target.value;
      const streets = this.params.street.data.filter(
        item => item.codestreet === value
      );
      if (streets.length > 0) {
        this.searchSubscribersForm.streetCode = value;
      } else {
        this.searchSubscribersForm.streetCode = null;
        this.searchSubscribersForm.codestreetCode = null;
      }
    },
    onChangeCodedistrictCode(event) {
      const value = event.target.value;
      const regions = this.params.gregion.data.filter(
        item => item.coder === value
      );
      if (regions.length > 0) {
        this.searchSubscribersForm.districtCode = value;
      } else {
        this.searchSubscribersForm.districtCode = null;
        this.searchSubscribersForm.codedistrictCode = null;
      }
    },
    onChangeCodestatusPayCode(event) {
      const value = event.target.value;
      const statuspays = this.params.statuspay.data.filter(
        item => item.coderr === value
      );
      if (statuspays.length > 0) {
        this.paymentForm.statusPayCode = value;
      } else {
        this.paymentForm.statusPayCode = null;
        this.paymentForm.codestatusPayCode = null;
      }
    },
    onChangeCodepurpPayCode(event) {
      const value = event.target.value;
      const statuspays = this.params.codepay.data.filter(
        item => item.codeplat === value
      );
      if (statuspays.length > 0) {
        this.paymentForm.purpPayCode = value;
      } else {
        this.paymentForm.purpPayCode = null;
        this.paymentForm.codepurpPayCode = null;
      }
    },
    onShortKeyRouter(event) {
      switch (event.srcKey) {
        case "F1":
          // searchSubscribersModal: call searchSubscribersFormHelp
          if (
            this.paymentModalVisible &&
            this.searchSubscribersModal &&
            !this.searchResultsModal
          ) {
            this.searchSubscribersFormHelp();
          }
          break;
        case "F2":
          // searchSubscribersModal: switching extendedSearch checkbox
          if (
            this.paymentModalVisible &&
            this.searchSubscribersModal &&
            !this.searchResultsModal
          ) {
            this.extendedSearch = !this.extendedSearch;
            // paymentModal: switching act checkbox
          } else if (
            this.paymentModalVisible &&
            !this.searchSubscribersModal &&
            !this.searchResultsModal &&
            !this.paymentForm.actDisabled &&
            !this.paymentFormIsDel
          ) {
            this.paymentForm.act = !this.paymentForm.act;
          }
          break;
        case "F3":
          // paymentModal: click show note button
          if (
            this.paymentModalVisible &&
            !this.searchSubscribersModal &&
            !this.searchResultsModal &&
            this.paymentForm.note &&
            !this.paymentFormIsDel
          ) {
            this.onClickPaymentNote();
          }
          break;
        case "F7":
          // paymentModal: call searchSubscribersModal
          if (
            this.paymentModalVisible &&
            !this.searchSubscribersModal &&
            !this.searchResultsModal &&
            !this.paymentFormIsDel
          ) {
            this.paymentFormSearch();
          }
          break;
        case "F10":
          // paymentModal: submit
          if (
            this.paymentModalVisible &&
            !this.searchSubscribersModal &&
            !this.searchResultsModal
          ) {
            this.paymentFormSubmit();
          }
          // searchSubscribersModal: submit
          else if (
            this.paymentModalVisible &&
            this.searchSubscribersModal &&
            !this.searchResultsModal
          ) {
            this.searchSubscribersFormSubmit();
          }
          // searchResultsModal: submit
          else if (
            this.paymentModalVisible &&
            !this.searchSubscribersModal &&
            this.searchResultsModal &&
            !this.submitSearchResultsBtnDisabled
          ) {
            this.searchResultsModalSubmit();
          }
          break;
        case "F12":
          // searchSubscribersModal: call searchSubscribersFormClear
          if (
            this.paymentModalVisible &&
            this.searchSubscribersModal &&
            !this.searchResultsModal
          ) {
            this.searchSubscribersFormClear();
          }
          break;
        case "Enter":
          // searchResultsModal: submit
          if (
            this.paymentModalVisible &&
            !this.searchSubscribersModal &&
            this.searchResultsModal &&
            !this.submitSearchResultsBtnDisabled
          ) {
            this.searchResultsModalSubmit();
          }
          break;
        case "Insert":
          // paymentModal: add
          if (
            this.paymentModalVisible &&
            !this.searchSubscribersModal &&
            !this.searchResultsModal
          ) {
            this.paymentFormAdd();
          }
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.info {
  color: #909399;
  font-weight: bold;
}

.abcode-not-found {
  color: brown;
  font-size: 2em;
  text-decoration: underline;
  font-weight: bold;
  text-align: center;
}

.mixed-input-no-radius .el-button {
  border-radius: 0px !important;
  border-color: transparent !important;
}

.grid-container-modal {
  height: calc(100vh - 180px);
  overflow-y: auto;
}

.grid-container-counters {
  height: 200px;
  overflow-y: auto;
}

.moneydisable {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  &:hover {
    border-color: #e4e7ed;
  }
}
</style>
